import { RoutemapMissedAlert } from '@/entities/alerts/card-missed';
import { Loader } from '@/shared/components/loader/loader';
import { RoutemapRequestError } from '@/entities/alerts/routemap-request-error';
import { useGetAllExecutorsQuery, useGetRubberTechMapByIdQuery } from '@/shared/state/api/swagger';

import { selectExecutorsForOptions } from '@/entities/employee';
import { useParams } from 'react-router-dom';
import { RubberOperationFillForm } from '@/widgets/operation';
import { RoutemapCloseAlert } from '@/entities/alerts';
import {
	RUBBER_TECHMAP_OPERATION_CLOSED_STATUSES,
	RUBBER_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES,
} from '../model/model';
import { IssueDetailsFormRubber } from '@/widgets/operation/ui';

export const RubberTechmapOperationPage = () => {
	const { rubberTechMapId } = useParams();
	const {
		data: techMap,
		isError: isTechMapError,
		isLoading: isTechMapLoading,
		error: techMapError,
	} = useGetRubberTechMapByIdQuery({ rubberTechMapId: Number(rubberTechMapId) });
	const { options: employees = [], isLoading: isEmployeesLoading } = useGetAllExecutorsQuery(
		{ stringToSearch: '' },
		{
			selectFromResult: (result) => ({
				...result,
				options: selectExecutorsForOptions(result?.data),
			}),
		},
	);

	if (isTechMapError) {
		if ('status' in techMapError && techMapError.status === 461) {
			return <RoutemapMissedAlert />;
		}
		return <RoutemapRequestError />;
	}

	if (isTechMapLoading || !techMap?.status || !techMap?.number || isEmployeesLoading || !techMap?.id) {
		return <Loader />;
	}

	// Если МК закрыта
	if (RUBBER_TECHMAP_OPERATION_CLOSED_STATUSES.includes(techMap?.status)) {
		return <RoutemapCloseAlert variant="rubber" productTechMapNumber={techMap?.number} />;
	}

	return (
		<div>
			{RUBBER_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES.includes(techMap?.status) && (
				<IssueDetailsFormRubber mappedEmployees={employees} techMap={techMap} />
			)}
			{techMap?.status === 'progress' && (
				<RubberOperationFillForm techMap={techMap} mappedEmployees={employees} />
			)}
		</div>
	);
};
